// i18n 核心：語系判定、t/nt 產生器。不含任何字典，主包（./index.js）與未登入包（./public/）各自帶字典呼叫 createI18n。
import { detectLang } from './detectLang'

export const SUPPORTED_LANGS = ['zh-Hant', 'zh-Hans', 'en']

export const lang = detectLang(localStorage.lang, navigator.language, navigator.languages)

function format(text, args) {
  for (const k of Object.keys(args)) {
    text = text.replaceAll(`{${k}}`, args[k])
  }
  return text
}

const warned = new Set()

export function createI18n(locales) {
  function t(scope, text, args = {}) {
    const hit = locales[lang]?.[scope]?.[text]
    if (hit != null) return format(hit, args)
    // 缺字：開發時警告一次（語言包應完整，scripts/i18n-check.js 會擋），畫面退回顯示 key
    if (import.meta.env.DEV && !warned.has(`${lang}:${scope}:${text}`)) {
      warned.add(`${lang}:${scope}:${text}`)
      console.warn(`[i18n] 缺少翻譯 ${lang} / ${scope} / ${text}`)
    }
    return format(text, args)
  }

  function nt(scope, text, textPlural, n, args = {}) {
    return n == 1 ? t(scope, text, args) : t(scope, textPlural, args)
  }

  return { t, nt }
}

export function setLang(code) {
  if (!SUPPORTED_LANGS.includes(code)) return
  localStorage.lang = code
  document.location.reload()
}
